module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_4_4.d35cf144.png";